var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectStoreBiogents(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_biogents)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8877 39C29.3191 39 37.7754 30.2696 37.7754 19.5C37.7754 8.73045 29.3191 0 18.8877 0C8.45631 0 0 8.73045 0 19.5C0 30.2696 8.45631 39 18.8877 39Z",
    fill: "#0080be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6533 19.7256C10.6533 19.3459 10.9266 19.0321 11.2812 18.9824L11.3798 18.9756H25.9088C26.31 18.9756 26.6352 19.3114 26.6352 19.7256C26.6352 20.1053 26.3619 20.4191 26.0074 20.4687L25.9088 20.4756H11.3798C10.9786 20.4756 10.6533 20.1398 10.6533 19.7256Z",
    fill: "#F5F4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5362 14.2326C19.2519 13.9404 19.2509 13.4655 19.534 13.172C19.7913 12.9051 20.1949 12.88 20.4797 13.0972L20.5613 13.1697L26.4214 19.1937C26.6806 19.4602 26.7042 19.8783 26.4921 20.1723L26.4214 20.2566L20.5614 26.2816C20.2771 26.5739 19.8171 26.5729 19.534 26.2794C19.2766 26.0126 19.254 25.5958 19.4656 25.3027L19.5361 25.2187L24.879 19.7248L19.5362 14.2326Z",
    fill: "#F5F4EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_biogents"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectStoreBiogents);
export default __webpack_public_path__ + "static/media/selectStoreBiogents.8e76b86b00a160ad23baeb4e98dede39.svg";
export { ForwardRef as ReactComponent };